import styled from 'styled-components';
import { media, vars } from '$util/theme';

export const Container = styled.div`
  padding: 0 15px;
  .title {
    font-weight: ${vars.fontWeight.semiBold};
    font-size: 1.5rem !important;
    padding-top: 15px;
    padding-bottom: 5px;
  }
  .input-group {
    display: flex;
    flex-direction: column;
    .FormItem.postcode {
      ${media.only('md')} {
        margin-right: 10px;
      }
    }
    ${media.up('md')} {
      flex-direction: row;
    }
  }
`;
